export const updateObjectProp = (obj: any, value: any, propPath: string) => {
  const [head, ...rest] = propPath.split('.')

  !rest.length
    ? (obj[head] = value)
    : updateObjectProp(obj[head], value, rest.join('.'))
}

// Example
// const user = { profile: { name: 'foo' } }
// updateObjectProp(user, 'fooChanged', 'profile.name')
